import { Button, Modal, ModalContent, ModalTitle, ModalActions, TextField,SearchAutocomplete,Typography } from '@deere/fuel-react'
import React ,{useState,useEffect,useRef} from 'react'
import { getBoundary } from "../../services/external.service";
import { GRAL_VALIDATION_MSGS} from '../../utils/constants.js'
import { useOktaAuth } from '@okta/okta-react'
import {getExtraGoldenRecordFields} from  '../../utils/cleansingUtils.js';
import {useUserInfo} from '../../providers/userProvider.js';

export const SubtierModal = ({showModal, setShowModal, labelBtnPrimary, submitFn, labelBtnSecondary,titleModal,goldenRecord,countryList}) => {
  const nameRef = useRef();
  const streetRef = useRef();
  const cityRef = useRef();
  const postalRef = useRef();
  const { authState } = useOktaAuth();
  const [statesList, setStatesList] = useState([]);
  const [formValidationErrs, setFormValidationErrs] = useState({});
  const [selectedCountry, setSelectedCountry] = useState((goldenRecord && goldenRecord.country) ? goldenRecord.country : '');
  const [selectedState, setSelectedState] = useState((goldenRecord && goldenRecord.state) ? goldenRecord.state : '');
  const tmpSelectedCountry = goldenRecord ? countryList.find((country) => country.label === goldenRecord.country ) : {};
  const userInfo = useUserInfo();
  const createdBy = userInfo? userInfo.userID : '';

  const onClose = () => {
      setShowModal(false)
  }

  const loadStates = async (country) => {
    if(country){
      let tmpStates = [];
      await getBoundary(authState.accessToken.accessToken, country.value)
          .then((response) => {
            if (response.length !== 0){
              if (response.length !== 0) response.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
              response.forEach((state) => tmpStates.push({label: state.name}));
            }
            setSelectedCountry(country.label);
            setStatesList(tmpStates);
          })
          .catch((err) => console.log(err));
    }else{
      setSelectedCountry('');
      setSelectedState('');
      setStatesList([]);
    }
  }

  useEffect(() => {
    tmpSelectedCountry && loadStates(tmpSelectedCountry);
  }, [tmpSelectedCountry]);

  const handleSubmit = event => {    
    event.preventDefault();
    
    const tmpName = nameRef.current.value;
    const tmpStreet = streetRef.current.value;
    const tmpCountry = selectedCountry;
    const tmpState = selectedState;
    const tmpCity = cityRef.current.value;
    const tmpPostal = postalRef.current.value;
    
    let tmpFormValidationErrs = null;
    tmpFormValidationErrs = (tmpName.trim() === '') ? {nameHelperTxt:true} : tmpFormValidationErrs;
    tmpFormValidationErrs = (tmpStreet.trim() === '') ?  {...tmpFormValidationErrs,streetHelperTxt:true}: tmpFormValidationErrs;
    tmpFormValidationErrs = (tmpCountry.trim() === '') ?  {...tmpFormValidationErrs,countryHelperTxt:true}: tmpFormValidationErrs;
    tmpFormValidationErrs = (tmpState.trim() === '' && statesList.length > 0) ? {...tmpFormValidationErrs,stateHelperTxt:true}: tmpFormValidationErrs;
    tmpFormValidationErrs = (tmpCity.trim() === '') ?  {...tmpFormValidationErrs,cityHelperTxt:true}: tmpFormValidationErrs;
    tmpFormValidationErrs = (tmpPostal.trim() === '') ?  {...tmpFormValidationErrs,postalHelperTxt:true}: tmpFormValidationErrs;
    
    if(tmpFormValidationErrs=== null){ 
      setFormValidationErrs({});  
    }else{
      setFormValidationErrs(tmpFormValidationErrs);
      return
    };
    
    const tmpGoldenRecord = {
      "ids": [goldenRecord.id],
      "supplierName": tmpName,
      "streetAddress": tmpStreet,
      "country": tmpCountry,
      "city": tmpCity,
      "state": tmpState,
      "postalCode": tmpPostal
    }

    const goldenRecordExtraFields = getExtraGoldenRecordFields(goldenRecord,createdBy);
    onClose();
    submitFn(tmpGoldenRecord,goldenRecordExtraFields);
  };

  return (countryList && statesList) && (
      <Modal
        open={showModal}
        onClose={onClose}
        aria-labelledby="alert-Modal-title"
        aria-describedby="alert-Modal-description"
      >
        <form onSubmit={handleSubmit}>
        <ModalTitle id="alert-Modal-title">{titleModal}</ModalTitle>
          <ModalContent>
              <TextField
                label="Name"
                type="text"
                helperText= {(formValidationErrs.nameHelperTxt===true) && GRAL_VALIDATION_MSGS.required_field}
                defaultValue={goldenRecord? goldenRecord.subtierSupplierName:''}
                inputRef = {nameRef}
                size = "small"
                
              />
              <TextField
                label="Street Address"
                type="text"
                helperText= {(formValidationErrs.streetHelperTxt===true) && GRAL_VALIDATION_MSGS.required_field}
                defaultValue={goldenRecord? goldenRecord.streetAddress:''}
                inputRef = {streetRef}
                size = "small"
              /> 
              <Typography fontWeight="semibold" gutterBottom size="sm">
                Country
              </Typography>
              <SearchAutocomplete
                options={countryList}
                placeholder="Country"
                size="small"
                onChange={(e,value)=>loadStates(value)}
                defaultValue={selectedCountry}
                InputProps={
                  {
                    helperText: (formValidationErrs.countryHelperTxt===true) && GRAL_VALIDATION_MSGS.required_field
                  }
                }
              />
              <Typography fontWeight="semibold" gutterBottom size="sm">
                State
              </Typography>
              <SearchAutocomplete
                options={statesList}
                placeholder="State"
                size="small"
                onChange={(e,value)=>value ? setSelectedState(value.label) : setSelectedState('')}
                defaultValue={selectedState}
                InputProps={
                  {
                    helperText: (formValidationErrs.stateHelperTxt===true) && GRAL_VALIDATION_MSGS.required_field
                  }
                }
              />
              <TextField
                label="City"
                type="text"
                helperText= {(formValidationErrs.cityHelperTxt===true) && GRAL_VALIDATION_MSGS.required_field}
                defaultValue={goldenRecord? goldenRecord.city:''}
                inputRef = {cityRef}
                size = "small"
              /> 
              <TextField
                label="Postal Code"
                type="text"
                helperText= {(formValidationErrs.postalHelperTxt===true) && GRAL_VALIDATION_MSGS.required_field}
                defaultValue={goldenRecord? goldenRecord.postalCode:''}
                inputRef = {postalRef}
                size = "small"
              />
          </ModalContent>
          <ModalActions>
            <Button onClick={onClose} variant="secondary">
              {labelBtnSecondary}
            </Button>
            <Button type={'submit'} variant={'primary'}>
              {labelBtnPrimary}
            </Button>
          </ModalActions>
          </form>
      </Modal>
  )
}